module.exports = __webpack_public_path__ + "img/cross_connector.e398214d.png";